/**

--------------------- Temporary not need js realisation ---------------------------------------

var toc = $('<ul></ul>').addClass("toc-list");
var el, title, link;

$("#main h2").each(function() {

  // Prepare the heading to become a link. Remove any special characters, replace spaces with dashes, change to lowercase
  var hyphenated = $(this).text().replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/\s/g,'-').toLowerCase();

  // Convert the heading to its link version
  $(this).attr('id', hyphenated);

  // Create variables for text and link version
  el = $(this);
  title = el.text();
  link = "#" + el.attr("id");

  // Create a list item using the text and link
  newLine =
    "<li>" + "<a href='" + link + "'>" + title + "</a>" + "</li>";

  // Add list item to table of contents
  toc.append(newLine);

});

// Add heading to table of contents section
//toc.prepend('<h4>Test:</h4>');
$('.toc-content').append(toc);

// Scroll to links in post
toc.find('a').on('click', function () {
  var $el = $(this)
    , id = $el.attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 75
  }, 500);

  return false;
});


*/
var toc = $('.toc-list');
toc.find('a').on('click', function () {
    var $el = $(this)
        , id = $el.attr('href');

    $('html, body').animate({
        scrollTop: $(id).offset().top - 75
    }, 500);

    return false;
});